import { render, staticRenderFns } from "./chat-offline.vue?vue&type=template&id=67904faa"
import script from "./chat-offline.vue?vue&type=script&lang=js"
export * from "./chat-offline.vue?vue&type=script&lang=js"
import style0 from "./chat-offline.vue?vue&type=style&index=0&id=67904faa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports